<div class="specs-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <!-- Dimensions Row -->
      <div class="dimensions-row">
        <div class="dimension-group">
          <label class="control-label" for="length">LENGTH</label>
          <div class="inputSpace">
            <input
              id="length"
              name="length"
              type="text"
              class="form-control dimension-input"
              [(ngModel)]="trailer.length"
              (ngModelChange)="onFieldChange()"
              [disabled]="!isEditMode"
            />
          </div>
        </div>
        <div class="dimension-group">
          <label class="control-label" for="width">WIDTH</label>
          <div class="inputSpace">
            <input
              id="width"
              name="width"
              type="text"
              class="form-control dimension-input"
              [(ngModel)]="trailer.width"
              (ngModelChange)="onFieldChange()"
              [disabled]="!isEditMode"
            />
          </div>
        </div>
        <div class="dimension-group">
          <label class="control-label" for="height">HEIGHT</label>
          <div class="inputSpace">
            <input
              id="height"
              name="height"
              type="text"
              class="form-control dimension-input"
              [(ngModel)]="trailer.height"
              (ngModelChange)="onFieldChange()"
              [disabled]="!isEditMode"
            />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="ladenWeight">LADEN WEIGHT</label>
        <div class="col-md-6 inputSpace">
          <input
            id="ladenWeight"
            name="ladenWeight"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.ladenWeight"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="unladenWeight">UNLADEN WEIGHT</label>
        <div class="col-md-6 inputSpace">
          <input
            id="unladenWeight"
            name="unladenWeight"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.unladenWeight"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="axles">AXLES</label>
        <div class="col-md-6 inputSpace">
          <input
            id="axles"
            name="axles"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.axles"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="tireSize">TIRE SIZE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="tireSize"
            name="tireSize"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.tireSize"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="engineHours">ENGINE HOURS</label>
        <div class="col-md-6 inputSpace">
          <input
            id="engineHours"
            name="engineHours"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.engineHours"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>
  </div>
</div>
